// Kept free of `#lib/config` so per-app `layers.ts` unit tests needn't load the GeoServer client.

// GeoServer TMS `xyzTemplate` → MapLibre vector source: `{-y}` becomes `{y}` under `scheme: 'tms'`, `{format}` becomes `pbf`.
export function tmsVectorTiles(xyzTemplate: string): { tiles: [string]; scheme: 'tms' } {
	const url = decodeURI(xyzTemplate).replaceAll('{-y}', '{y}').replaceAll('{format}', 'pbf');
	return { tiles: [url], scheme: 'tms' };
}
